import { z } from 'zod';
import { PAYMENT_TERMS } from '../constants/paymentTerms';

const emailList = z.array(z.string().trim().email()).min(1);

export const sendInvoiceSchema = z.object({
  /** Omitted = use resolution. Present = compared against resolution and may become the override (FR-4.4). */
  recipients: emailList.optional(),
  subject: z.string().trim().min(1).max(300),
  body: z.string().trim().min(1).max(10_000),
  /**
   * Required. Terms are a per-invoice decision made at send time (there is no
   * client-level default to fall back on), so the server never has to guess
   * one, and an invoice cannot leave the building without the sender having
   * looked at what it promises the customer.
   */
  paymentTerms: z.enum(PAYMENT_TERMS),
});
export type SendInvoiceInput = z.infer<typeof sendInvoiceSchema>;
